module.exports = __webpack_public_path__ + "static/media/reward-catalouge-6.b89f18a1.png";